/* global axios */
import ApiClient from './ApiClient';

class ProposalAPI extends ApiClient {
  constructor() {
    super('proposals', { accountScoped: true });
  }

  get({ contactId, page } = {}) {
    const params = new URLSearchParams();
    if (contactId) params.set('contact_id', contactId);
    if (page) params.set('page', page);
    const query = params.toString();
    return axios.get(query ? `${this.url}?${query}` : this.url);
  }

  sendEmail(id) {
    return axios.post(`${this.url}/${id}/send_email`);
  }

  sendWhatsapp(id) {
    return axios.post(`${this.url}/${id}/send_whatsapp`);
  }

  // Dry-run of the server's pricing calculator - creates nothing, returns
  // the Year 1 / Year 2+ breakdown so the wizard can show it before the
  // salesperson commits.
  preview(proposal) {
    return axios.post(`${this.url}/preview`, { proposal });
  }
}

export default new ProposalAPI();
